<template>
  <div class="LegalPeopleInfo">
   <van-cell-group>
      <van-field
        readonly
        clickable
        :label="label"
        :value="this.$store.state.commonForms.locationText"
        :placeholder="placeholder"
        right-icon="arrow"
        class="term"
        @click="showLocationPlacePicker=true"
      />
       <van-popup v-model="showLocationPlacePicker" position="bottom" :style="{ height: '40%' }">
        <van-area :area-list="areaList"  @confirm='comfirmPlace'  @cancel="showLocationPlacePicker=false" />
      </van-popup>
    </van-cell-group>
  </div>
</template>

<script>
// @ is an alias to /src
// import { Field, version } from "vant";
// import ValidHoc from "../../../../components/valid";
import service from '@/request/api'; // 导入api接口
// const ValidVanField = ValidHoc(Field);
export default {
  name: 'LocatedPlacePicker',
  props: [
    'label',
    'placeholder',
    'model',
  ],
  data() {
    return {
      showLocationPlacePicker: false,
      areaList: {},
    };
  },
  mounted() {
    service.CommonForms.getAreaList().then((res) => {
      this.areaList = res.data;
    }).catch((e) => {
      console.log(e);
    });
  },
  methods: {
    comfirmPlace(value) {
      const tempArry = this.model.split('/');
      this.showLocationPlacePicker = false;
      let temp = '';
      value.forEach((item) => {
        temp += `${item.name} `;
      });
      this.$store.commit('commonForms/updateForm', {
        [tempArry[0]]: value[0].name,
        [tempArry[1]]: value[1].name,
        [tempArry[2]]: value[2].name,
        [tempArry[3]]: value[2].code,
        locationText: temp,
      });
    },
  },
};
</script>
<style>
.bgColor {
  background: #f8f8f9;
}
</style>
